import { ConsumerTripUpsertMutation, ConsumerTripUpsertMutationVariables } from "gql/gql-request";
import { z } from "zod";

import { SelectorInput, SelectorInputTypeEnum } from "@holibob-packages/graphql-types";

import { ConsumerTripCookieSchema } from "./ConsumerTripCookieSchema";

export type ConsumerTripWithOptionalSelector = Omit<ConsumerTripUpsertMutationVariables["input"], "selector"> & {
    selector?: ConsumerTripUpsertMutationVariables["input"]["selector"];
};
export type ConsumerTripInput = ConsumerTripUpsertMutationVariables["input"];

export type ConsumerTripData = ConsumerTripUpsertMutation["consumerTrip"];

export type ConsumerTripCookieData = z.input<typeof ConsumerTripCookieSchema>;

export function getNewIdSelector(id?: string): SelectorInput {
    return { type: SelectorInputTypeEnum.Id, value: id ?? crypto.randomUUID() };
}
